import Plyr from "plyr";

window.addEventListener('load', () => {
	const supportsAudio = !!document.createElement('audio').canPlayType;
	const audioPlayers = document.querySelectorAll('div[data-audio-player]');
	if (supportsAudio) {
		for (let audioPlayer of audioPlayers) {
			// initialize playlist and controls
			const cmsGeneratedPlaylistTracks = audioPlayer.querySelectorAll('ul[data-playlist] > li[data-track]');
			const playPauseButton = audioPlayer.querySelector('button[data-audio-play]');
			const audioPlayerElement = audioPlayer.querySelector('audio[data-audio-element]')
			const playlistContainer = audioPlayer.querySelector('ul[data-playlist]');
			let tracks = [];

			// initialize plyr
			new Plyr(audioPlayer.querySelector('audio[data-audio-element]'), {
				controls: [
					'progress',
					'mute',
					'volume',
				]
			});

			for (let track of cmsGeneratedPlaylistTracks) {
				tracks.push({
					'track': track.dataset.number,
					'name': track.dataset.name,
					'duration': track.dataset.duration,
					'file': track.dataset.location,
				});
			}

			let trackIndex = 0;
			let playing = false;
			const trackCount = tracks.length;
			const playlistItems = playlistContainer.querySelectorAll('li');

			const loadTrack = function (trackId) {
				// remove all currently-selected classes from playlist item
				audioPlayer.querySelectorAll('.currently-selected').forEach((currentlyPlayingItem) => {
					currentlyPlayingItem.classList.remove('currently-selected');
				});

				// remove currently playing and selected classes from all playlist elements
				// and adds selected to the current selected item
				playlistItems.forEach((playlistItem,currentIndex) => {
					playlistItem.classList.remove('currently-playing');
					if (currentIndex === trackId) {
						playlistItem.classList.add('currently-selected');
					}
				});

				trackIndex = trackId;
				audioPlayerElement.src = tracks[trackId].file;
			};

			const playTrack = function (id) {
				loadTrack(id);
				startPlayer();
			};

			const pausePlayer = () => {
				audioPlayerElement.pause();
				playing = false;
				playPauseButton.dataset.playing = 'false';
			}

			const startPlayer = () => {
				audioPlayerElement.play();
				playing = true;
				playPauseButton.dataset.playing = 'true';
			}

			audioPlayerElement.addEventListener('play', function () {
				playing = true;
				playPauseButton.dataset.playing = 'true';
				audioPlayer.querySelectorAll('.currently-selected').forEach((currentlyPlayingItem) => {
					currentlyPlayingItem.classList.add('currently-playing');
					currentlyPlayingItem.classList.remove('currently-paused');
				});
			});

			audioPlayerElement.addEventListener('pause', function () {
				playing = false;
				playPauseButton.dataset.playing = 'false';
				audioPlayer.querySelectorAll('.currently-selected').forEach((currentlyPlayingItem) => {
					currentlyPlayingItem.classList.add('currently-paused');
					currentlyPlayingItem.classList.remove('currently-playing');
				});
			});

			audioPlayerElement.addEventListener('ended', function () {
				if ((trackIndex + 1) < trackCount) {
					trackIndex++;
					loadTrack(trackIndex);
					startPlayer();

					audioPlayer.querySelectorAll('.currently-selected').forEach((currentlyPlayingItem) => {
						currentlyPlayingItem.classList.add('currently-playing');
						currentlyPlayingItem.classList.remove('currently-paused');
					});
				} else {
					pausePlayer();

					trackIndex = 0;
					loadTrack(trackIndex);
					audioPlayer.querySelectorAll('.currently-selected').forEach((currentlyPlayingItem) => {
						currentlyPlayingItem.classList.add('currently-paused');
						currentlyPlayingItem.classList.remove('currently-playing');
					});
				}
			});

			audioPlayer.querySelector('button[data-audio-previous]')?.addEventListener('click', function () {
				if (trackIndex === 0) {
					pausePlayer();
					audioPlayerElement.currentTime = 0;
				} else {
					trackIndex--;
					loadTrack(trackIndex);

					if (playing) {
						startPlayer();
					}
				}
			});

			audioPlayer.querySelector('button[data-audio-next]')?.addEventListener('click', () => {
				if ((trackIndex + 1) === trackCount) {
					loadTrack(0)

					playing ? startPlayer() : pausePlayer();
				} else {
					trackIndex++;
					loadTrack(trackIndex);

					playing ? startPlayer() : pausePlayer();
				}
			})

			audioPlayer.querySelector('button[data-audio-play]')?.addEventListener('click', () => {
				playing ? pausePlayer() : startPlayer();
			});

			// functions for playing items in playlist when clicked
			playlistItems.forEach((playlistItem, elementIndex) => {
				playlistItem.addEventListener('click', function () {
					if (elementIndex !== trackIndex) {
						playTrack(elementIndex);
					} else {
						playing ? pausePlayer() : startPlayer();
					}
				});

			})

			loadTrack(trackIndex);
		}
	}
});